import React, { useState, useEffect } from "react";
import { object, func, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import chunk from "lodash/chunk";

import Headline from "../../../atoms/headline";
import TwelveStoryMixedDesign from "../../../rows/twelve-story-mixed-design";
import LoadMore from "../../../atoms/loadmore";
import Whatsapp from "../../../atoms/icons/whatsapp";
import PregaNewsIcon from "../../../atoms/icons/prega-news-icon";

import translate from "../../../translate";

import { setLoading } from "../../../helper/actions";
import { loadMoreCollectionItems } from "../../../helper/api";

import "./load-more-section-items.m.css";

const NO_OF_ITEMS_LOAD = 12;

const LoadMoreSectionItems = ({ collection, publisherName, pageNum, setLoading, navigateToPage, currentPath }) => {
  if (!(collection && collection.items)) {
    return null;
  }

  const storyList = collection.items.filter((item) => item.type === "story").map((item) => item.story);

  useEffect(() => {
    if (pageNum && !storyList.length) {
      const urlPath = currentPath.replace(/\/$/, "");
      const urlParams = urlPath.split("/") || [];
      urlParams.pop();
      console.log("url.join(" / ")==", urlParams.join("/"));
      navigateToPage(urlParams.join("/"));
    }
  }, []);

  if (!storyList.length) {
    return null;
  }

  const [stories, setStories] = useState(storyList || []);
  const [noMoreStories, setNoMoreStories] = useState(false);
  const [pageNumber, setPageNumber] = useState(pageNum || 0);

  const list = chunk(stories, 12);
  const isMoreStories = NO_OF_ITEMS_LOAD <= storyList.length && !noMoreStories; // fix it

  const updateUrl = (nextPage) => {
    const urlPath = window.location.pathname.replace(/\/$/, "");
    const urlParams = urlPath.split("/") || [];
    const pageNumPosition = pageNumber ? urlParams.length - 1 : urlParams.length;
    urlParams[pageNumPosition] = nextPage;
    const newPath = urlParams.join("/");
    global.app.maybeSetUrl(`${newPath}`);
  };

  const handleLoadMore = () => {
    setLoading(true);
    const nextPageNumber = Number(pageNumber) + 1;
    setPageNumber(nextPageNumber);
    loadMoreCollectionItems(collection.slug, nextPageNumber)
      .then((items) => {
        setStories([...stories, ...items]);
        setNoMoreStories(items.length < NO_OF_ITEMS_LOAD);
        updateUrl(nextPageNumber);
      })
      .finally(() => setLoading(false));
  };

  const getcollectionTitle = () => {
    return (
      <div styleName={collection.name === "#SheIsCompleteInHerself" ? "prega-headline-wrapper" : "headline-wrapper"}>
        <Headline text={collection.name} headerType={9} />
        {collection.name === "#PrivacyMatters" && (
          <div styleName="powered-by-whatsapp">
            powered by
            <Whatsapp />
          </div>
        )}
        {collection.name === "#SheIsCompleteInHerself" && (
          <div styleName="powered-by-prega">
            powered by
            <PregaNewsIcon />
          </div>
        )}
      </div>
    );
  };

  return (
    <div styleName="wrapper" className="container">
      {collection.template !== "top-story" ? getcollectionTitle() : null}
      {collection.summary && <div styleName="summary">{collection.summary}</div>}
      <React.Fragment>
        <div styleName="story-list">
          {list.map((itemList, index) => (
            <TwelveStoryMixedDesign
              key={index}
              list={itemList}
              className={isMoreStories && index + 1 === list.length ? "twelve-story-mixed-design" : ""}
            />
          ))}
        </div>

        {isMoreStories && <LoadMore onClick={handleLoadMore} content={translate(publisherName, "load_more")} />}
      </React.Fragment>
    </div>
  );
};

LoadMoreSectionItems.propTypes = {
  collection: object.isRequired,
  setLoading: func,
  publisherName: string,
  pageNum: string,
  navigateToPage: func,
  currentPath: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadMoreSectionItems);
